/* AGM · Escenas 2.0 (29-sep-2026) — motor común de las demos «Pruébalo tú» de la ficha.
   Cada producto trae su dibujo en snippets/agm-escena-<nombre>.liquid y registra su lógica con
   (window.AGMEscQ = window.AGMEscQ || []).push(['<nombre>', function(A){ ... }]);
   Este archivo pone lo que todas comparten:
   - bucle de dibujo que SOLO corre mientras algo se mueve y la escena está a la vista (en reposo, cero trabajo);
   - gestos con el dedo en coordenadas del dibujo (400×300), tolerantes: no hay que apuntar fino;
   - partículas reutilizadas (aire, agua, jugo, chispas) con tope fijo, sin crear nodos en cada cuadro;
   - medidor, aviso de logro con «Lo quiero» (usa el botón real «Agregar al carrito» de la ficha) y vibración suave;
   - los 4 pasos de «Ver cómo funciona» (evento agm:paso que manda sections/agm-ficha-plus). */
(function(){
  if(window.AGMEsc && window.AGMEsc.v === 2) return;
  var NS = 'http://www.w3.org/2000/svg';
  var reduce = false;
  try{ reduce = matchMedia('(prefers-reduced-motion: reduce)').matches; }catch(e){}

  function lim(v, a, b){ return v < a ? a : (v > b ? b : v); }
  function mix(a, b, t){ return a + (b - a) * t; }
  function suave(t){ t = lim(t, 0, 1); return t * t * (3 - 2 * t); }
  /* acerca v a meta con una velocidad que no depende de los cuadros por segundo */
  function acercar(v, meta, vel, dt){ return meta + (v - meta) * Math.exp(-vel * dt); }

  function crear(caja){
    var svg = caja.querySelector('svg');
    var raiz = caja.closest('.agmfp') || document.body;
    var A = {caja:caja, svg:svg, raiz:raiz, reduce:reduce, lim:lim, mix:mix, suave:suave, acercar:acercar, usuario:false};

    A.$ = function(s){ return caja.querySelector(s); };
    A.$$ = function(s){ return [].slice.call(caja.querySelectorAll(s)); };
    A.el = function(tag, at, padre){
      var e = document.createElementNS(NS, tag);
      for(var k in at) e.setAttribute(k, at[k]);
      if(padre) padre.appendChild(e);
      return e;
    };
    /* escribe en el dibujo solo si el valor cambió: menos repintados en el celular */
    A.att = function(e, k, v){
      if(!e) return;
      v = '' + v; var c = e._a || (e._a = {});
      if(c[k] === v) return; c[k] = v; e.setAttribute(k, v);
    };
    A.txt = function(e, v){ if(!e) return; v = '' + v; if(e._t === v) return; e._t = v; e.textContent = v; };
    A.css = function(e, k, v){ if(!e) return; var c = e._c || (e._c = {}); if(c[k] === v) return; c[k] = v; e.style.setProperty(k, v); };

    /* ---------- bucle ---------- */
    var tareas = [], corriendo = false, visible = !('IntersectionObserver' in window), t0 = 0;
    A.cada = function(fn){ tareas.push(fn); A.despertar(); };
    function bucle(ahora){
      if(!visible || document.hidden){ corriendo = false; return; }
      var dt = lim((ahora - t0) / 1000, 0, .05); t0 = ahora;
      var sigue = false;
      for(var i = 0; i < tareas.length; i++){
        try{ if(tareas[i](dt)) sigue = true; }catch(err){ if(window.console) console.warn('AGM escena', err); }
      }
      if(moverParticulas(dt)) sigue = true;
      if(sigue) requestAnimationFrame(bucle); else corriendo = false;
    }
    A.despertar = function(){
      if(corriendo || !visible || document.hidden) return;
      corriendo = true; t0 = performance.now(); requestAnimationFrame(bucle);
    };
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(en){ visible = en[0].isIntersecting; if(visible) A.despertar(); }, {rootMargin:'80px'}).observe(caja);
    }
    document.addEventListener('visibilitychange', function(){ if(!document.hidden) A.despertar(); });

    /* ---------- gestos ---------- */
    var rect = null;
    addEventListener('resize', function(){ rect = null; }, {passive:true});
    function pt(e){
      var r = rect || (rect = svg.getBoundingClientRect());
      var vb = svg.viewBox.baseVal;
      return {x:(e.clientX - r.left) / r.width * vb.width, y:(e.clientY - r.top) / r.height * vb.height};
    }
    /* h = {bajar(p), mover(p, d, total), subir(p, total)}; d = cuánto se movió desde el último evento (en el dibujo) */
    A.gesto = function(h){
      var on = false, ult = null, ini = null;
      svg.addEventListener('pointerdown', function(e){
        on = true; A.usuario = true; rect = svg.getBoundingClientRect();
        try{ svg.setPointerCapture(e.pointerId); }catch(_){}
        var p = pt(e); ult = ini = p;
        A.ocultarPista();
        if(h.bajar) h.bajar(p, e);
        A.despertar();
      });
      svg.addEventListener('pointermove', function(e){
        if(!on) return;
        var p = pt(e), d = {x:p.x - ult.x, y:p.y - ult.y}; ult = p;
        if(h.mover) h.mover(p, d, {x:p.x - ini.x, y:p.y - ini.y}, e);
        A.despertar();
      });
      function fin(e){
        if(!on) return; on = false;
        var p = pt(e);
        if(h.subir) h.subir(p, {x:p.x - ini.x, y:p.y - ini.y}, e);
        A.despertar();
      }
      svg.addEventListener('pointerup', fin);
      svg.addEventListener('pointercancel', fin);
      svg.addEventListener('lostpointercapture', fin);
    };

    /* ---------- partículas (un solo grupo, nodos reutilizados) ---------- */
    var capa = A.$('[data-particulas]'), pool = [], vivas = 0;
    if(capa){
      var n = +capa.getAttribute('data-particulas') || 36;
      for(var i = 0; i < n; i++){
        var c = A.el('circle', {r:'0', cx:'-20', cy:'-20', opacity:'0'}, capa);
        pool.push({e:c, vida:0});
      }
    }
    /* o = {vx, vy, g (gravedad), vida (s), r, r2 (radio final), color, op, arrastre} */
    A.soltar = function(x, y, o){
      if(reduce || !pool.length) return;
      for(var i = 0; i < pool.length; i++){
        var q = pool[i];
        if(q.vida > 0) continue;
        q.x = x; q.y = y; q.vx = o.vx || 0; q.vy = o.vy || 0; q.g = o.g || 0; q.ar = o.arrastre || 0;
        q.vida = q.v0 = o.vida || .8; q.r = o.r || 2; q.r2 = o.r2 == null ? q.r : o.r2; q.op = o.op == null ? .9 : o.op;
        A.att(q.e, 'fill', o.color || '#f2efe8');
        vivas++; A.despertar();
        return;
      }
    };
    function moverParticulas(dt){
      if(!vivas) return false;
      for(var i = 0; i < pool.length; i++){
        var q = pool[i];
        if(q.vida <= 0) continue;
        q.vida -= dt;
        if(q.vida <= 0){ vivas--; A.att(q.e, 'opacity', '0'); continue; }
        q.vy += q.g * dt;
        if(q.ar){ var f = Math.exp(-q.ar * dt); q.vx *= f; q.vy *= f; }
        q.x += q.vx * dt; q.y += q.vy * dt;
        var k = 1 - q.vida / q.v0;
        A.att(q.e, 'cx', q.x.toFixed(1)); A.att(q.e, 'cy', q.y.toFixed(1));
        A.att(q.e, 'r', mix(q.r, q.r2, k).toFixed(1));
        A.att(q.e, 'opacity', (q.op * (1 - k * k)).toFixed(2));
      }
      return vivas > 0;
    }

    /* ---------- superficies que se limpian / cosas que se barren ----------
       campo = lista de puntos {x, y, e, ...}; barrer marca los que caen dentro de un círculo;
       enCono dice si un punto está dentro del chorro (origen, ángulo en radianes, largo y abertura) */
    A.campo = function(lista){ return {p:lista, vivos:lista.length, total:lista.length}; };
    A.barrer = function(c, x, y, r, alTocar){
      var r2 = r * r, n = 0;
      for(var i = 0; i < c.p.length; i++){
        var q = c.p[i]; if(q.fuera) continue;
        var dx = q.x - x, dy = q.y - y;
        if(dx * dx + dy * dy < r2){ q.fuera = 1; c.vivos--; n++; if(alTocar) alTocar(q); }
      }
      return n;
    };
    A.hecho = function(c){ return c.total ? 1 - c.vivos / c.total : 1; };
    A.enCono = function(px, py, ox, oy, ang, largo, abre){
      var dx = px - ox, dy = py - oy, d = Math.sqrt(dx * dx + dy * dy);
      if(d > largo || d < 1) return 0;
      var a = Math.atan2(dy, dx) - ang;
      while(a > Math.PI) a -= 2 * Math.PI; while(a < -Math.PI) a += 2 * Math.PI;
      return Math.abs(a) < abre ? 1 - d / largo : 0;
    };
    /* hoja/escama/miga: forma pequeña reutilizable */
    A.forma = function(padre, d, color, x, y){ return A.el('path', {d:d, fill:color, transform:'translate(' + x + ' ' + y + ')'}, padre); };

    /* ---------- vibración suave (solo si la persona está tocando la escena) ---------- */
    A.vibrar = function(ms){
      if(!A.usuario || reduce) return;
      try{ if(navigator.vibrate) navigator.vibrate(ms || 12); }catch(e){}
    };

    /* ---------- medidor ---------- */
    var hv = A.$('[data-hud-v]'), hb = A.$('[data-hud-bar]'), hm = A.$('[data-hud-m]');
    A.medidor = function(valor, progreso, meta){
      A.txt(hv, valor);
      if(hb) A.css(hb, 'transform', 'scaleX(' + lim(progreso, 0, 1).toFixed(3) + ')');
      if(meta != null) A.txt(hm, meta);
    };

    /* ---------- pista (texto bajo el cuadro, lo dibuja la ficha) ---------- */
    var pista = raiz.querySelector && raiz.querySelector('[data-pista]');
    var pistaSvg = A.$('[data-pista-svg]');
    A.pista = function(t){ if(pista) pista.textContent = t; };
    A.ocultarPista = function(){ if(pistaSvg) A.att(pistaSvg, 'opacity', '0'); };

    /* ---------- logro + «Lo quiero» ---------- */
    var logro = A.$('[data-logro]'), yaLogro = false;
    A.logro = function(titulo, detalle){
      if(!logro) return;
      A.txt(logro.querySelector('[data-logro-t]'), titulo);
      A.txt(logro.querySelector('[data-logro-d]'), detalle || '');
      logro.hidden = false;
      void logro.offsetWidth;
      logro.classList.add('is-on');
      if(!yaLogro){ yaLogro = true; A.vibrar([14, 60, 22]); }
    };
    A.sinLogro = function(){ if(logro){ logro.classList.remove('is-on'); logro.hidden = true; } };
    if(logro){
      var quiero = logro.querySelector('[data-quiero]');
      if(quiero) quiero.addEventListener('click', function(){
        var b = document.querySelector('form[action$="/cart/add"] button[name="add"]:not([disabled])');
        if(b){ b.click(); quiero.textContent = 'Agregado al carrito'; quiero.disabled = true; }
        else {
          var f = document.querySelector('form[action$="/cart/add"]');
          if(f) f.scrollIntoView({behavior:'smooth', block:'center'});
        }
      });
      var otra = logro.querySelector('[data-otra]');
      if(otra) otra.addEventListener('click', function(){ A.sinLogro(); if(A.reiniciar) A.reiniciar(); A.despertar(); });
    }

    /* ---------- pasos de «Ver cómo funciona» ---------- */
    A.alPaso = function(fn){
      raiz.addEventListener('agm:paso', function(ev){ fn(ev.detail.i); A.despertar(); });
    };

    return A;
  }

  function montar(nombre, fn){
    var cajas = document.querySelectorAll('[data-esc2="' + nombre + '"]');
    for(var i = 0; i < cajas.length; i++){
      var c = cajas[i];
      if(c._esc) continue; c._esc = 1;
      try{ fn(crear(c)); }catch(e){ if(window.console) console.error('AGM escena ' + nombre, e); }
    }
  }
  function cuandoListo(f){ if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', f); else f(); }

  var pendientes = window.AGMEscQ && window.AGMEscQ.slice ? window.AGMEscQ.slice() : [];
  window.AGMEsc = {v:2, def:function(n, f){ cuandoListo(function(){ montar(n, f); }); }};
  window.AGMEscQ = {push:function(x){ window.AGMEsc.def(x[0], x[1]); }};
  pendientes.forEach(function(x){ window.AGMEsc.def(x[0], x[1]); });
})();
